<div class="d-flex kt-margin-bottom-10-mobile col-right-last">
    <input style="height: 32px;" nz-input
           [placeholder]="placeHolder"
           [(ngModel)]="searchValue"
           [ngModelOptions]="{standalone: true}"
           id="input-search"
           [maxlength]="inputLength"
           trim="blur"
           (keyup.enter)="search()"
           (keydown.enter)="$event.preventDefault()"
    />
    <button nz-button nzType="primary" (click)="search()" class="btn-search" [disabled]="searchValue.length > inputLength">
        <span nz-icon nzType="search"></span>
    </button>
</div>
